import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl text-background-50"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50"><strong>红桃影视</strong></span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              免费高清影视资源一站畅享。最新电影、热门电视剧、综艺动漫，无需下载即可流畅播放。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4"><strong>内容分类</strong></h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap">{cat.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4"><strong>快速链接</strong></h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">关于我们</Link></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">常见问题</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">使用条款</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4"><strong>联系我们</strong></h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-accent-500"></i>
                <span>contact@hongtaomovies.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-wechat-line text-accent-500"></i>
                <span>红桃影视官方</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-time-line text-accent-500"></i>
                <span>9:00 - 21:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; 2020-2026 <strong>红桃影视</strong> HongTao Movies. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center text-foreground-400 hover:bg-accent-500 hover:text-foreground-950 transition-colors" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center text-foreground-400 hover:bg-accent-500 hover:text-foreground-950 transition-colors" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center text-foreground-400 hover:bg-accent-500 hover:text-foreground-950 transition-colors" aria-label="B站" rel="nofollow">
              <i className="ri-bilibili-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}